module.exports = __webpack_public_path__ + "static/media/ugrant-illustrator.3067e7d6.svg";